export const DISPOSITIONS_GET_ALL = 'DISPOSITIONS_GET_ALL'
export const DISPOSITIONS_GET_ACTIVE = 'DISPOSITIONS_GET_ACTIVE'
export const DISPOSITION_TYPES_GET_ALL = 'DISPOSITION_TYPES_GET_ALL'
export const SET_SELECTED_RESOLUTION = 'SET_SELECTED_RESOLUTION'
export const SET_SELECTED_TOPIC = 'SET_SELECTED_TOPIC'
export const ADD_NEW_RESOLUTION = 'ADD_NEW_RESOLUTION'
export const UPDATE_RESOLUTION = 'UPDATE_RESOLUTION'
export const SAVE_TOPIC = 'SAVE_TOPIC'
export const FOLLOWUPRESULTTYPES_GET_ACTIVE = 'FOLLOWUPRESULTTYPES_GET_ACTIVE'


// WEBPACK FOOTER //
// ./src/store/modules/dispositions/mutation-types.js